module.exports = __webpack_public_path__ + "img/icon-sort-1-down.83286af9.svg";